export enum StorageKey {
  GuardianFeaturePresentationSeen = 'guardian-feature-presentation-seen',
  GuardianTutorialSeen = 'guardian-tutorial-seen',
  TemporaryFestivalStartDate = 'temporary-festival-start-date',
  AppleUser = 'apple_user',
  PreferredLang = 'preferred-language',
  ThemeMode = 'theme-mode',
  AccessToken = 'access-token',
  RefreshToken = 'refresh-token',
  CurrentUserId = 'current-user-id',
  SubscriptionEndedPaywall = 'subscription-ended-paywall',
  LoginAsEmail = 'login-as-email',
  LoginAsUserId = 'login-as-user-id',
  CelebratedSuperSharer = 'celebrated-super-sharer-level',
  ListingsFiltersGroups = 'listings-filters-groups',
  ListingsFiltersAddresses = 'listings-filters-addresses',
  ListingsFiltersCategories = 'listings-filters-categories',
  ListingsFiltersTags = 'listings-filters-tags',
  ListingsFiltersServiceCategories = 'listings-filters-service_categories',
  ListingsFiltersSubtypes = 'listings-filters-subtypes',
  ListingsFiltersHideFoundRequests = 'listings-filters-hide-found-requests',
  ListingsFiltersHideDismissedRequests = 'listings-filters-hide-dismissed-requests',
  ListingsFiltersHideOffersWithFee = 'listings-filters-hide-offers-with-fee',
  ListingsFiltersTransactionModes = 'listings-filters-transaction-modes',
  CalendarPrompts = 'calendar-prompts',
  RefrainBlockedDatesPopupWasShownLenderBefore = 'refrain-block-dates-popup-was-shown-lender-before',
  RefrainBlockedDatesPopupWasShownLenderAfter = 'refrain-block-dates-popup-was-shown-lender-after',
  RefrainBlockedDatesPopupWasShownBorrower = 'refrain-block-dates-popup-was-shown-borrower',
  NewlyInsuredModalShown = 'newly-insured-modal-shown',
  ListingsVisibilityExclusionsPreference = 'listings-visibility-exclusions-preferences',
  NumAppStarts = 'num-app-starts',
  CustomModalsShown = 'custom-modals-shown',
  ClosestOffersModalShown = 'closest-offers-modal-shown',
  CodeConfirmationsShown = 'code-confirmations-shown',
  ConciergerieBottomSheetsShown = 'conciergerie-bottom-sheets-shown',
  InsuredOptionalComponentsVisible = 'insured-optional-components-visible',
  B2BActivatedModalShown = 'b2b-activated-modal-shown',
  InviteOthersPromptVisible = 'invite-others-prompt-visible',
  ClosedBonificationBanner = 'closed-bonification-banner',
  ClosedMyListingsBonificationBanner = 'closed-my-listings-bonification-banner',
  ClosedCompletedProfileBanner = 'closed-completed-profile-banner',
  PublicUserWelcomeShown = 'public-user-welcome-shown',
  ChooseSharerTypeModalShown = 'choose-sharer-type-modal-shown',
  GeneratedDeviceUUID = 'generated-device-uuid',
  PromptPhoneNumberBannerSeen = 'prompt-phone-number-banner-seen',
  TemporaryAddressUsed = 'temporary-address-used',
  StreakFlameIgnited = 'streak-flame-ignited',
  ListFormat = 'list-format',
  ExplorationMode = 'exploration-mode',
  BulkListingSessionId = 'bulk-listing-session-id',
  AppDownloadGuestPromptShown = 'app-download-guest-prompt-shown',
  AppDownloadBannerDismissed = 'app-download-banner-dismissed',
  PreferredApiBaseUrl = 'preferred-api-base-url',
  RegionMigrationAttempt = 'region-migration-attempt',
  LastAuthenticationMethod = 'last-authentication-method',
}
